// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalUiSemantics = {
  uiSemanticsTitle: "UI 语义概览",
  uiSemanticsSubtitle: "统一查看 Admin 操作语义、图标与颜色映射。",
  uiSemanticsNotice: "同一语义动作应复用同一 semantic key，以保证图标和 token 颜色一致。",
  uiSemanticsTableTitle: "语义映射表",
  uiSemanticsColumnSemantic: "语义",
  uiSemanticsColumnChineseLabel: "中文语义",
  uiSemanticsColumnIcon: "图标",
  uiSemanticsColumnColor: "颜色 token",
  uiSemanticsPreviewTitle: "AdminRowActions 预览",
  uiSemanticsLegendTitle: "Legend 语义映射表",
  uiSemanticsLegendColumnSemantic: "Legend Semantic",
  uiSemanticsLegendColumnDefaultLabel: "默认文案",
  uiSemanticsLegendColumnBadge: "Badge",
  uiSemanticsLegendColumnColor: "标准颜色(token)",
  uiSemanticsLegendUndefined: "未定义图例语义：{value}",
} as const;
